/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

/*
{
  "ambient":{"humidity":[65.3],"temperature":[8.3],"ts":[1680512285000]},
  "current":{
    "ts":[1680512285000],
    "values":[-0.527]
  },
  "meta":{"end":1680514317,"start":1679909517},
  "voltage":{
    "ts":[1680512285000],
    "values":[10.11]
  }
}
*/

export class CarHistoryDTO {

  public last_voltage
  public last_current
  public last_update
  public last_temperature
  public last_humidity

  ambient: {
    temperature: [{
      values: number
    }],
    ts: [{
      values: number
    }],
    humidity: [{
      values: number
    }]
  }
  current: [{
    ts: string
    values: number
  }]

  meta: string = ''
  voltage: [{
    ts: string
    values: number
  }]


  public setDTOFromWSData(data: any) {

    this.ambient = data.ambient
    this.current = data.current
    this.ambient.temperature = data.ambient.temperature
    this.current = data.current
    this.meta = data.meta
    this.voltage = data.voltage
    this.ambient.humidity = data.ambient.humidity

    //// //console.log(this)

    if (this.current!==null) {
      this.last_current = this.current.values[this.current.values.length - 1]
    }
    if (this.voltage!==null) {
      this.last_voltage = this.voltage.values[this.voltage.values.length - 1]
    }
    if (this.ambient.temperature!==null) {
      this.last_temperature = this.ambient.temperature[this.ambient.temperature.length - 1]
    }
    if (this.ambient.humidity!==null) {
      this.last_humidity = this.ambient.humidity[this.ambient.humidity.length - 1]
    }
    if (this.ambient.ts!==null) {
      this.last_update = this.ambient.ts[this.ambient.ts.length - 1]
    }

    //// //Base.log('[' + this._page + '] info', 'last current: ', this.last_current)
    //// //Base.log('[' + this._page + '] info', 'last voltage: ', this.last_voltage)
    //// //Base.log('[' + this._page + '] info', 'last temperature: ', this.last_temperature)
    //// //Base.log('[' + this._page + '] info', 'last humidity: ', this.last_humidity)

  }

}
